import { createContext, useContext, useMemo, useState } from 'react';

interface BranchContextType {
  selectedBranch: string;
  setSelectedBranch: (branch: string) => void;
}

const BranchContext = createContext<BranchContextType | undefined>(undefined);

export function BranchProvider({ children }: { children: React.ReactNode }) {
  const [selectedBranch, setSelectedBranch] = useState('');
  const contextValue = useMemo(() => ({ selectedBranch, setSelectedBranch }), [selectedBranch]);

  return <BranchContext.Provider value={contextValue}>{children}</BranchContext.Provider>;
}

export const useBranch = () => {
  const context = useContext(BranchContext);
  if (!context) {
    throw new Error('useBranch deve ser usado dentro de um BranchProvider');
  }
  return context;
};
